/**
* Copyright (c) 2020, WSO2 Inc. (http://www.wso2.org) All Rights Reserved.
*
* WSO2 Inc. licenses this file to you under the Apache License,
* Version 2.0 (the "License"); you may not use this file except
* in compliance with the License.
* You may obtain a copy of the License at
*
*     http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied. See the License for the
* specific language governing permissions and limitations
* under the License.
*/

export const OP_IFRAME = "opIFrame";
export const RP_IFRAME = "rpIFrame";
export const PROMPT_NONE_IFRAME = "promptNoneIFrame";
export const STATE = "Y2hlY2tTZXNzaW9u";
export const SILENT_SIGN_IN_STATE = "sign-in-silently";
export const INITIALIZED_SIGN_IN = "initialized-sign-in";
export const INITIALIZED_SILENT_SIGN_IN = "initialized-silent-sign-in";
export const PROMPT_NONE_REQUEST_SENT = "promptNoneRequestSent";
